import React, { memo } from "react";

const Friend = memo(() => {
	return (
		<div>
			<h2>朋友</h2>
		</div>
	);
});

export default Friend;
